import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { ImageUploadModal } from '../albums/image-upload-modal';
import { ArchiveUnpackModal } from '../archives/archive-unpack-modal';
import { ArchiveUnpackingModal } from '../archives/archive-unpacking-modal';
import { ArchiveUploadModal } from '../archives/archive-upload-modal';
import { CouponCreateForm } from '../coupons/coupon-create-form';
import { CoverUploadModal } from '../events/cover-upload-modal';
import { EventCreateForm } from '../events/event-create-form';
import { NewFieldForm } from '../form-builder/new-field-form';
import { OrderSendEmailForm } from '../orders/order-send-email-form';
// import { CreateAddOn } from '../products/create-add-on';
import { CreateProduct } from '../products/create-product';
import { LogoUploadModal } from '../settings/logo-upload-modal';
import { WatermarkUploadModal } from '../settings/watermark-upload-modal';
import { CreateUser } from '../users/create-user';
import { ModalContentEmpty } from './content/empty';
import styles from './modal.module.css';
import { selectModal, close } from './modalSlice';

export const Modal = () => {
  const modalData = useAppSelector(selectModal);
  const dispatch = useAppDispatch();
  return (
    <div
      className={`${styles.modal__bg} ${
        modalData.isOpen ? styles.modal__bg__open : ''
      }`}
      onClick={(e) => {
        if (modalData.backgroundClose && e.currentTarget === e.target) {
          dispatch(close());
        }
      }}
    >
      <div className={styles.modal}>
        <div className={styles.modal__title}>{modalData.title}</div>
        <div className={styles.modal__content}>
          {modalData.contentKey === '' && <ModalContentEmpty />}
          {modalData.contentKey === 'event-cover-upload' && (
            <CoverUploadModal
              eventId={modalData.contentPayload?.eventId ?? ''}
            />
          )}
          {modalData.contentKey === 'album-cover-upload' && (
            <CoverUploadModal
              albumId={modalData.contentPayload?.albumId ?? ''}
            />
          )}
          {modalData.contentKey === 'album-image-upload' && (
            <ImageUploadModal
              albumId={modalData.contentPayload?.albumId ?? ''}
            />
          )}
          {modalData.contentKey === 'send-order-email' && (
            <OrderSendEmailForm
              orderId={modalData.contentPayload?.orderId ?? ''}
              initialEmail={modalData.contentPayload?.initialEmail}
            />
          )}
          {modalData.contentKey === 'create-coupon' && <CouponCreateForm />}
          {modalData.contentKey === 'add-field' && (
            <NewFieldForm onFieldCreated={modalData.callback} />
          )}
          {modalData.contentKey === 'create-event' && <EventCreateForm />}
          {modalData.contentKey === 'create-product' && <CreateProduct />}
          {modalData.contentKey === 'create-user' && <CreateUser />}
          {modalData.contentKey === 'archive-upload' && <ArchiveUploadModal />}
          {modalData.contentKey === 'watermark-upload' && (
            <WatermarkUploadModal />
          )}
          {modalData.contentKey === 'logo-upload' && (
            <LogoUploadModal
              variant={modalData.contentPayload?.variant ?? 'default'}
            />
          )}
          {modalData.contentKey === 'create-addon' && (
            <CreateProduct addOnFor={modalData.contentPayload?.productId} />
          )}
          {modalData.contentKey === 'unpack-archive' && (
            <ArchiveUnpackModal
              filename={modalData.contentPayload?.filename}
              eventId={modalData.contentPayload?.eventId}
            />
          )}
          {modalData.contentKey === 'archive-unpacking-modal' && (
            <ArchiveUnpackingModal taskId={modalData.contentPayload.taskId} />
          )}
        </div>
      </div>
    </div>
  );
};
